'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'far';
var iconName = 'bandage';
var width = 576;
var height = 512;
var aliases = [129657,"band-aid"];
var unicode = 'f462';
var svgPathData = 'M448 144l0 224 64 0c8.8 0 16-7.2 16-16l0-192c0-8.8-7.2-16-16-16l-64 0zM400 96l112 0c35.3 0 64 28.7 64 64l0 192c0 35.3-28.7 64-64 64L64 416c-35.3 0-64-28.7-64-64L0 160c0-35.3 28.7-64 64-64l336 0zM176 144l0 224 224 0 0-224-224 0zm-48 0l-64 0c-8.8 0-16 7.2-16 16l0 192c0 8.8 7.2 16 16 16l64 0 0-224zm112 40a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm72 24a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm-72 72a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm72 24a24 24 0 1 1 48 0 24 24 0 1 1 -48 0z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faBandage = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;